export const webClientId = process.env.REACT_APP_GOOGLE_WEB_CLIENT_ID || '206683174745-vle35j5q34ot36b6shrm8fbusbplokfh.apps.googleusercontent.com';